import ActionTypes from "./ActionTypes";

export const updateCart = (payload) => ({ type: ActionTypes.UPDATE_CART, payload});
export const updateUserData = (payload) => ({ type: ActionTypes.UPDATE_USER_DATA, payload});
export const updateProductData = (payload) => ({ type: ActionTypes.UPDATE_PRODUCT_DATA, payload});
export const deleteProductData = (payload) => ({ type: ActionTypes.DELETE_PRODUCT_DATA, payload});


// WEBPACK FOOTER //
// ./src/app/catalogo/actions/index.js